import RegistrationCnPage from "./RegistrationCnPage";
export default RegistrationCnPage